import TextField from "@/components/form/hook-form/textfield";
import { StackedModal } from "@/components/modal/stacked-modal";
import { cn } from "@/utils/cn";
import { textVariants } from "@/utils/text-variants";
import { memo, useRef } from "react";
import { useForm } from "react-hook-form";

interface AddFromLinkModalProps {
  pageRef: React.RefObject<HTMLElement>;
  isOpen: boolean;
  onDismiss: () => void;
  onSubmit: (url: string) => void;
}

interface AddLinkFormValues {
  url: string;
}

export const AddFromLinkModal = memo(function AddFromLinkModal({
  pageRef,
  isOpen,
  onDismiss,
  onSubmit,
}: AddFromLinkModalProps) {
  const { control, reset, watch } = useForm<AddLinkFormValues>({
    defaultValues: {
      url: "",
    },
  });
  const inputRef = useRef<HTMLInputElement>(null!);

  const urlValue = watch("url");

  const handleModalPresented = () => {
    inputRef.current.focus();
  };

  const onFormSubmit = (data: AddLinkFormValues) => {
    if (data.url.trim()) {
      onSubmit(data.url.trim());
      reset();
    }
  };

  const handleDismiss = () => {
    reset();
    onDismiss();
  };

  return (
    <StackedModal
      pageRef={pageRef}
      isOpen={isOpen}
      onDidDismiss={handleDismiss}
      onDidPresent={handleModalPresented}
      title="Add your food"
      showHeader={true}
      showConfirmButton={true}
      onConfirm={() => onFormSubmit({ url: urlValue })}
    >
      <div className="flex flex-col gap-6 pt-5">
        <p className={cn(textVariants.body, "mx-10 px-4 text-center")}>
          Paste a TikTok, Instagram or website link and I'll get the food from there
        </p>

        <div className="px-9">
          <TextField
            control={control}
            name="url"
            type="url"
            placeholder="Paste address"
            className="rounded-full"
            inputRef={inputRef}
          />
        </div>
      </div>
    </StackedModal>
  );
});
